(function($, Global) {
    var MenuLeftComponent = function() {
        this.isShown = false;
    };

    MenuLeftComponent.prototype.initEvents = function() {
        this.publishers();
    }

    MenuLeftComponent.prototype.publishers = function() {
        var self = this;

        $(document).on('click', '[data-toggle="menuLeft"], .menuleft', function(e) {
            if ($(this).attr('href') && $(this).attr('href').indexOf('#') >= 0) {
                collapsePanel($(this).attr('href'))
            }
            self.toggle(e);
        });

        $(document).on('click', '.menuleft #pays .btn-action, .menuleft .close, .menuleft .newsletter-button a', function(e) {
            e.stopPropagation();

            self.isShown = false;
            $('body, .menuleft, .menuleft-backdrop').removeClass('in');           
        });

        $(document).on('show.bs.collapse', '.menuleft .panel-group .panel', function () {
            var $panelHeading = $(this).find('.panel-heading');
            $panelHeading.addClass('active');
            $panelHeading.find('.icon').removeClass('icon-1').addClass('icon-2');
        });
        $(document).on('hide.bs.collapse', '.menuleft .panel-group .panel', function () {
            var $panelHeading = $(this).find('.panel-heading');
            $panelHeading.removeClass('active');
            $panelHeading.find('.icon').removeClass('icon-2').addClass('icon-1');
        });
    }

    MenuLeftComponent.prototype.toggle = function(e) {
        return this.isShown ? this.hide(e) : this.show(e)
    }

    MenuLeftComponent.prototype.show = function() {
        if (this.isShown) return;

        $('body, .menuleft, .menuleft-backdrop').addClass('in');

        this.isShown = true;
    }

    MenuLeftComponent.prototype.hide = function(e) {
        var $target = $(e.target);

        if (!this.isShown) return;

        if ($target.closest('.menuleft-body').exists() && !$target.hasClass('close')) return;

        $('body, .menuleft, .menuleft-backdrop').removeClass('in');

        this.isShown = false;
    }

    function collapsePanel(rub) {
        if (rub.length > 1 && $('.menuleft ' + rub).exists()) {
            $('.menuleft .panel-heading.active').removeClass('active');
            $('.menuleft .panel-collapse.show').removeClass('show');
            $('.menuleft ' + rub).collapse('show');
        }
    }

    Global.MenuLeftComponent = MenuLeftComponent;
}(jQuery, window));